import { useGoalsTranslations } from 'modules/iterableGoals/hooks';
import { ChevronRightSmall } from 'ui/icons/navigation/ChevronRightSmall';
import { colors } from 'ui/theme/colors';
import { LinkText, LinkWrapper } from './Styled';

type LinkProps = {
  campaignId: number;
};

export const Link = ({ campaignId }: LinkProps) => {
  const { t } = useGoalsTranslations();

  return (
    <LinkWrapper>
      <LinkText target="_blank" to={`/analytics/campaignPerformance?campaignId=${campaignId}`}>
        {t('labels.performantCampaigns.campaignAnalytics')}
      </LinkText>
      <ChevronRightSmall color={colors.link} />
    </LinkWrapper>
  );
};
